import { Typography } from '@mui/material';

export const AISuggestionsTitle = () => (
  <Typography variant="body1" fontWeight={600}>
    AI Proposed Name
  </Typography>
);
